module.exports = __webpack_public_path__ + "static/media/shawarma-plate.9520d160.jpg";